import { SpliteButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useNewNavigate } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Flex, Text } from "@chakra-ui/react";
import { type RoomListType } from "../../../otherRoomPreview/otherRoomPreview.type";

export const RoomImgSlide = ({ rooms, currentIdx }: { currentIdx: number; rooms: RoomListType[] }) => {
    const { onNavigate } = useNewNavigate();
    const { MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();

    return (
        <Flex
            position="relative"
            flex="1 !important"
            maxW="none !important"
            minHeight={isMobile ? "none" : "970px"}
            h="100%"
            alignItems="flex-end"
            flexDir={isMobile ? "column-reverse" : "row"}
        >
            <Flex
                position={isMobile ? "relative" : "absolute"}
                top="0"
                w="100%"
                justifyContent="flex-end"
                pl={isMobile ? "16px" : "0"}
            >
                <Box w={isMobile ? "100%" : "auto"} overflow="hidden" borderTopRightRadius="88px">
                    <Flex
                        w={isMobile ? "100%" : "504px"}
                        h="100%"
                        flexDir="row-reverse"
                        transform={`translateX(${currentIdx * 100}%)`}
                        transition="transform 0.5s ease-in-out"
                    >
                        {rooms.map((t) => (
                            <Box
                                flexShrink="0"
                                key={t.room_idx}
                                w={isMobile ? "100%" : "504PX"}
                                h={isMobile ? "256px" : "686px"}
                                background={
                                    t.imgList[0] ? `url(${t.imgList[0].img_URL})no-repeat center/cover` : "gray.100"
                                }
                            />
                        ))}
                    </Flex>
                </Box>
            </Flex>

            <Flex w="100%" flexDir="column" zIndex="2">
                <Flex
                    w="100%"
                    h={isMobile ? "64px" : "126px"}
                    p={isMobile ? "0 24px" : "0 48px"}
                    alignItems="center"
                    justifyContent={isMobile ? "flex-end" : "flex-start"}
                >
                    <Text color="#F5F3EF" {...FONT("cormorant", isMobile ? 40 : 104, 700, 1.2)}>
                        ROOMS
                    </Text>
                </Flex>
                <Flex alignItems="flex-end" display={isTablet ? "none" : "flex"}>
                    <Box overflow="hidden" maxW="728px" w="100%" borderBottomRightRadius="88px">
                        <Flex
                            w="728px"
                            h="100%"
                            flexDir="row-reverse"
                            transform={`translateX(${currentIdx * 100}%)`}
                            transition="transform 0.5s ease-in-out"
                        >
                            {rooms.map((t) => (
                                <Box
                                    flexShrink="0"
                                    key={t.room_idx}
                                    w="728px"
                                    h="576px"
                                    background={
                                        t.imgList[1] ? `url(${t.imgList[1].img_URL})no-repeat center/cover` : "gray.100"
                                    }
                                />
                            ))}
                        </Flex>
                    </Box>
                    {!isMobile && (
                        <Box mb="80px">
                            <SpliteButton
                                text="MoreView"
                                onClick={() => onNavigate({ path: `/rooms/${rooms[currentIdx].room_idx}` })}
                            />
                        </Box>
                    )}
                </Flex>
            </Flex>
        </Flex>
    );
};
